"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useCreateReview = require("./useCreateReview");
Object.keys(_useCreateReview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCreateReview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useCreateReview[key];
    }
  });
});
var _useDeleteReview = require("./useDeleteReview");
Object.keys(_useDeleteReview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useDeleteReview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useDeleteReview[key];
    }
  });
});
var _useGetReview = require("./useGetReview");
Object.keys(_useGetReview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetReview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetReview[key];
    }
  });
});
var _useUpdateReview = require("./useUpdateReview");
Object.keys(_useUpdateReview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useUpdateReview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useUpdateReview[key];
    }
  });
});
